export default {
      id: "drag-big-usage",
      viewBox: "0 0 31 21",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#drag-big",
      toString: function () {
        return this.url;
      }
    }